export default [
  {
    // FEATURES 1
    id: 401,
    type: "features",
    title: "Features Block",
    template: "block-features1",
    hasScript: false,
    firebase: false,
    required: [],
    options: {
      fullHeight: false,
      bg: {
        url: null,
        color: "#ffffff"
      },
      title: {
        text: "Welcome to Cortexial",
        colorTheme: "g-color--primary"
      },
      subtitle: {
        text:
          "We Create Beautiful Experiences <br> That Drive Successful Businesses.",
        colorTheme: "g-color--base"
      },
      features: [
        {
          id: 1,
          icon: { code: "ti-desktop", colorTheme: "g-color--primary" },
          title: { text: "Responsive Layout", colorTheme: "g-color--base" },
          subtitle: {
            text:
              "This is where we sit down, grab a cup of coffee and dial in the details.",
            colorTheme: "g-color--base"
          }
        },
        {
          id: 2,
          icon: { code: "ti-settings", colorTheme: "g-color--primary" },
          title: { text: "Fully Customizable", colorTheme: "g-color--base" },
          subtitle: {
            text:
              "This is where we sit down, grab a cup of coffee and dial in the details.",
            colorTheme: "g-color--base"
          }
        },
        {
          id: 3,
          icon: { code: "ti-ruler-alt-2", colorTheme: "g-color--primary" },
          title: { text: "Pixel Perfect", colorTheme: "g-color--base" },
          subtitle: {
            text:
              "This is where we sit down, grab a cup of coffee and dial in the details.",
            colorTheme: "g-color--base"
          }
        },
        {
          id: 4,
          icon: { code: "ti-package", colorTheme: "g-color--primary" },
          title: { text: "Endless Possibilities", colorTheme: "g-color--base" },
          subtitle: {
            text:
              "This is where we sit down, grab a cup of coffee and dial in the details.",
            colorTheme: "g-color--base"
          }
        },
        {
          id: 5,
          icon: { code: "ti-star", colorTheme: "g-color--primary" },
          title: { text: "Powerful Performance", colorTheme: "g-color--base" },
          subtitle: {
            text:
              "This is where we sit down, grab a cup of coffee and dial in the details.",
            colorTheme: "g-color--base"
          }
        },
        {
          id: 6,
          icon: { code: "ti-panel", colorTheme: "g-color--primary" },
          title: { text: "Parallax Support", colorTheme: "g-color--base" },
          subtitle: {
            text:
              "This is where we sit down, grab a cup of coffee and dial in the details.",
            colorTheme: "g-color--base"
          }
        }
      ]
    },
    settings: [
      { el: "fullHeight", title: "Full Height", type: "toggle" },
      { el: "bg", title: "Background URL", type: "image" },
      { el: "bg.color", title: "Background Color", type: "color" },
      { el: "title.colorTheme", title: "Title Color", type: "colorTheme" },
      {
        el: "subtitle.colorTheme",
        title: "Subtitle Color",
        type: "colorTheme"
      },
      {
        el: "features",
        title: "Features",
        type: "array",
        children: [
          { el: "icon.code", title: "Feature Icon", type: "icon" },
          {
            el: "icon.colorTheme",
            title: "Feature Icon Color",
            type: "colorTheme"
          },
          { el: "title.text", title: "Feature Icon Title", type: "input" },
          {
            el: "title.colorTheme",
            title: "Feature Icon Title Color",
            type: "colorTheme"
          },
          {
            el: "subtitle.text",
            title: "Feature Icon Subtitle",
            type: "input"
          },
          {
            el: "subtitle.colorTheme",
            title: "Feature Icon Subtitle Color",
            type: "colorTheme"
          }
        ]
      }
    ]
  }
];



// WEBPACK FOOTER //
// ./src/util/blockTemplatesFeatures.js